// SERVER-ONLY. Shared by sitemap.ts and the llms.txt route so both stay in
// sync with whatever blog posts the API currently has.
import { endPoint } from "@/utils";
import { serverFetch } from "@/utils/serverFetch.util";

export interface BlogListItem {
  blogCode: string;
  title?: string;
  excerpt?: string;
  updatedAt?: string;
  createdAt?: string;
}

export async function fetchBlogList(): Promise<BlogListItem[]> {
  try {
    const res = await serverFetch({
      endpoint: endPoint.BLOGS_URL,
      method: "POST",
    });

    return res.map((blog: BlogListItem) => ({
      blogCode: blog.blogCode,
      title: blog.title,
      excerpt: blog.excerpt,
      updatedAt: blog.updatedAt,
      createdAt: blog.createdAt,
    }));
  } catch {
    // Callers should still render their static content rather than fail outright.
    return [];
  }
}
